<template>
  <div
    class="py-4 p-st"
    :class="{
      'bg-light': !nightMode,
      'bg-dark2': nightMode,
      'text-light': nightMode,
    }"
  >
    <div class="container">
      <div
        class="text-center"
        data-aos="fade"
        data-aos-once="true"
        data-aos-duration="1000"
      >
        <span
          class="title text-center"
          :class="{ pgray: !nightMode, 'text-light': nightMode }"
          >About Me.</span
        >
      </div>
      <hr
        width="50%"
        :class="{ pgray: !nightMode, 'bg-secondary': nightMode }"
      />
      <div class="row">
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12">
          <Timeline :data="education" :nightMode="nightMode" />
        </div>
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12">
          <Timeline :data="experience" :nightMode="nightMode" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Timeline from "./helpers/Timeline";
import info from "../../info";

export default {
  name: "About",
  components: {
    Timeline,
  },
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      education: {
        title: "education",
        data: info.education,
      },
      experience: {
        title: "experiences",
        data: info.experience,
      },
    };
  },
};
</script>

<style scoped>
.title {
  font-size: 30px;
  font-weight: 500;
  letter-spacing: -0.3px;
  line-height: 1.2;
  margin-bottom: 0.5rem;
}

@media only screen and (min-width: 769px) {
  .title {
    font-size: 30px;
    letter-spacing: -0.2px;
    text-align: center;
  }
}

/* Mobile responsive About section */
@media only screen and (max-width: 768px) {
  .title {
    font-size: 26px;
    letter-spacing: -0.1px;
    text-align: center;
    margin-bottom: 0.8rem;
  }

  hr {
    width: 70% !important;
  }
}

@media only screen and (max-width: 580px) {
  .title {
    font-size: 24px;
    letter-spacing: -0.1px;
    text-align: center;
    margin-bottom: 1rem;
  }

  .row {
    margin-top: 1rem;
  }

  .col-xl-6,
  .col-bg-6,
  .col-md-6,
  .col-sm-12 {
    margin-bottom: 1.5rem;
  }
}
</style>
